import { RouteProps, useNavigate, useParams } from "react-router-dom";
import TGButton from "src/components/ui/TGButton";
import ActionsReport from "./ActionsReport/ActionsReport";
import DeviationReport from "./DeviationReport/DeviationReport";
import FiveWhyReport from "./FiveWhyReport/FiveWhyReport";
import MatrixReport from "./MatrixReport";
import { IncidentsReport } from "./IncidentsReport/IncidentsReport";
import IncidentsReportFromEmail from "./IncidentsReportFromEmail";
import Report5SAudits from "./Report5SAudits/Report5SAudits";
import ReportDone5SAudit from "./ReportDone5SAudit/ReportDone5SAudit";

const myTaskReportRoutes: Record<string | number, RouteProps> = {
  1: {
    path: "/1",
    Component: ActionsReport,
  },
  2: {
    path: "/2",
    Component: FiveWhyReport,
  },
  3: {
    path: "/3",
    Component: DeviationReport,
  },
  4: {
    path: "/4",
    Component: IncidentsReport,
  },
  6: {
    path: "/6",
    Component: IncidentsReportFromEmail,
  },
  5: {
    path: "/5",
    Component: MatrixReport,
  },
  7: {
    path: "/7",
    Component: Report5SAudits,
  },
  8: {
    path: "/8",
    Component: ReportDone5SAudit,
  },
};

export function MyTaskReportCard() {
  const navigate = useNavigate();
  const { reportID } = useParams();
  // Преобразуем reportID в число
  const route = myTaskReportRoutes[reportID!];

  if (!route || !route.Component) {
    return (
      <div className="flex p-10 space-x-2">
        <TGButton
          onClick={() =>
            navigate("/dashboard/3/reports", {
              preventScrollReset: true,
            })
          }
          color="bluedark"
        >
          Вернуться в отчеты
        </TGButton>
        <TGButton
          onClick={() =>
            navigate("/dashboard/3", {
              preventScrollReset: true,
            })
          }
          color="bluedark"
        >
          Вернуться на главную
        </TGButton>
      </div>
    );
  }

  const { Component } = route;

  return <Component />;
}
